<template>
  <div class="ids-select">
    <!-- 伪输入，展示区 -->
    <div :class="[{'fake-input-active': isIdsSelectShow}, 'fake-input']" @click="fakeInputClickHandler">
      <div class="fake-input-placeholder" v-if="!idsSelectValueString">{{idsSelectPlaceholder}}</div>
      <div class="fake-input-value">{{idsSelectValueString}}</div>
      <div class="fake-input-btn">{{ $bp_t('选择', 'common.choice') }}</div>
    </div>
    <!-- 弹窗，实际输入区 -->
    <byted-modal
      v-model="isIdsSelectShow"
      class="dialog-ids-select"
      ref="select-panel-modal"
      :title="modalTitle"
      :mask-closable="true"
    >
      <div slot="body">
        <div class="ids-select-content">
          <!-- 搜索 -->
          <div class="search-area">
            <!-- 输入 -->
            <byted-input
              v-model="searchInput"
              :placeholder="inputPlaceholder"
              prefix="search"
            ></byted-input>
          </div>
          <select-panel-filterable
            ref="selectPanel"
            v-model="selectedIds"
            :optionList="panelOptions"
            :isLoading="isSelectPanelLoading"
            :searchInput="searchInput"
            :panelTitle="[panelTitle]"
          >
          </select-panel-filterable>
        </div>
      </div>
      <template slot="footer">
        <byted-button type="default" @click="cancelBtnHandler">{{ $bp_t('取消', 'common.cancel') }}</byted-button>
        <byted-button type="info" @click="applyBtnHandler">{{ $bp_t('应用', 'common.application') }}</byted-button>
      </template>
    </byted-modal>
  </div>
</template>

<script>
import SelectPanel from './select-panel-filterable.vue'

export default {
  name: 'select-panel-modal',
  components: {
    [SelectPanel.name]: SelectPanel
  },
  props: {
    modalTitle: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    panelOptions: {
      type: Array,
      default: () => []
    },
    panelTitle: {
      type: String,
      default: ''
    },
    inputPlaceholder: {
      type: String,
      default: ''
    },
    isSelectPanelLoading: {
      type: Boolean,
      default: true
    },
    isInited: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isIdsSelectShow: false,
      searchInput: '',
      isSearchLoading: false,
      selectedIds: this.value
    }
  },
  computed: {
    idsSelectPlaceholder () {
      return $bp_t('请选择', 'common.please_choose') + this.label
    },
    idsSelectValueString () {
      const selectedCount = this.value.length
      return selectedCount ? $bp_t(`已选${selectedCount}项`, 'common.selected_filter_term', { data: selectedCount }) : ''
    }
  },
  watch: {
    value (val) {
      this.selectedIds = val
    },
    isIdsSelectShow (newVal) {
      // 关闭modal时直接返回
      if (!newVal) return
      this.selectedIds = this.value
      // 打开modal时设置默认数据
      // 设置search选项
      this.searchInput = ''

      if (!this.isInited) {
        this.$emit('selectPanelShow', newVal)
      }
    }
  },
  mounted () {
    this.$refs['select-panel-modal']?.$el?.addEventListener('click', (e) => {
      //  阻断冒泡
      e.cancelBubble = true
      e.stopPropagation?.()
    })
  },
  methods: {
    fakeInputClickHandler () {
      this.isIdsSelectShow = true
    },
    cancelBtnHandler () {
      this.isIdsSelectShow = false
    },
    applyBtnHandler () {
      this.$emit('input', this.selectedIds)
      this.isIdsSelectShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/basic/theme.scss";

.fake-input {
  height: 34px;
  width: 210px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  position: relative;
  line-height: 20px;

  .fake-input-placeholder {
    color: $color-text-holder;
  }

  .fake-input-value {
    color: $color-border-underline;
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .fake-input-btn {
    cursor: pointer;
    color: $color-active-light;
    font-size: 14px;
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  }

  &:hover {
    border-color: #2f88ff !important;
  }

  &.fake-input-active {
    border-color: #2f88ff !important;
    box-shadow: 0 0 0 2px rgba(47, 136, 255, 0.2);
  }
}

.dialog-ids-select {
  .bui-modal-dialog {
    width: 662px;
  }
  .ids-select-content {
    .search-area {
      width: 400px;
      position: relative;
    }
    .select-ids-panel {
      margin-top: 16px;
      display: flex;
    }
    .byted-popover-wrapper {
      display: block;
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.select-panel {
  /deep/.bui-select-panel-left {
    display: none;
  }
}

.select-panel-search {
  width: calc(100% - 214px);
  margin-right: 16px;
  /deep/.bui-select-panel-right {
    display: none;
  }
}
</style>
